import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const createEntityGroup = (payload: object) =>
  post(`${config.API_URL}/entity-mapping/group`, payload);

export const getEntityGroups = (queryRequest: string) =>
  get(`${config.API_URL}/entity-mapping/group?${queryRequest}`);

export const deleteSpecificEntityGroup = (id: string) =>
  Delete(`${config.API_URL}/entity-mapping/group/${id}`);

export const createChildEntityGroup = (payload: object) =>
  post(`${config.API_URL}/entity-mapping`, payload);

export const getChildEntityGroups = (queryRequest: string) =>
  get(`${config.API_URL}/entity-mapping?${queryRequest}`);

export const deleteSpecificChildEntityGroup = (id: string) =>
  Delete(`${config.API_URL}/entity-mapping/${id}`);

export const updateChildEntityGroup = (id: string, payload: object) =>
  patch(`${config.API_URL}/entity-mapping/${id}`, payload);

export const updateChildEntityGroupStatus = (payload: object) =>
  // patch(`${config.API_URL}/entity-mapping/${id}`, payload);
  patch(`${config.API_URL}/entity-mapping/bulk/active-inactive`, payload);

//user entity mapping

export const getUserEntityGroups = (queryRequest: string) =>
  get(`${config.API_URL}/user-entity-permissions/groups?${queryRequest}`);

export const getUserEntityGroupsItems = (queryRequest: string) =>
  get(`${config.API_URL}/user-entity-permissions/groups/items?${queryRequest}`);

export const getUserChildEntities = (queryRequest: string) =>
  get(`${config.API_URL}/user-entity-permissions?${queryRequest}`);

export const getSpecificUserChildEntities = (id: string) =>
  get(`${config.API_URL}/user-entity-permissions/${id}`);

export const addUserChildEntity = (payload: object) =>
  post(`${config.API_URL}/user-entity-permissions`, payload);

export const updateUserChildEntity = (id: string, payload: object) =>
  patch(`${config.API_URL}/user-entity-permissions/${id}`, payload);

export const deleteUserChildEntity = (id: string) =>
  Delete(`${config.API_URL}/user-entity-permissions/${id}`);

export const getSCChildEntityGroups = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/entity-mapping?${queryRequest}`
  );

export const getATChildEntityGroups = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance/filters/entity-mapping?${queryRequest}`);


export const getEntityGroupsNew = (level: string, parent_id: string) =>
  get(`${config.API_URL}/user-entity-permissions/user/entity/level/${level}/${parent_id}`);
